import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// If you want to load from files at runtime, keep the HTTP backend.
// Since you're bundling JSON below, we don't need it.
//// import Backend from 'i18next-http-backend';

// Local bundles
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationFR_CA from './locales/fr-CA/translation.json';
import translationTR from './locales/tr/translation.json';

// Help system (step 9, design_handoff_help_system/README.md) content lives in
// its own namespace since it's large (~75 articles) and edited separately
// from product copy. Only `en` is authored for now — other locales fall back
// to it automatically via `fallbackLng` below, per namespace.
import helpEN from './locales/en/help.json';

const resources = {
  en: { translation: translationEN, help: helpEN },
  fr: { translation: translationFR },
  'fr-CA': { translation: translationFR_CA },
  tr: { translation: translationTR },
};

i18n
  // .use(Backend) // not needed if you bundle JSON
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: ['translation', 'help'],
    defaultNS: 'translation',
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'fr-CA', 'tr'],
    // IMPORTANT: keep 'fr-CA' case as-is so it matches the resources key
    lowerCaseLng: false,
    // Try only the exact code (e.g., 'fr-CA') and then fallbackLng
    load: 'currentOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'userLanguage',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    debug: process.env.NODE_ENV === 'development',
  });

// Keep DOM <html lang> + a data attribute in sync and persist
i18n.on('languageChanged', (lng) => {
  if (lng) {
    document.documentElement.lang = lng;
    document.body.setAttribute('data-language', lng);
    localStorage.setItem('userLanguage', lng);
  }
});

// Helper to change language manually elsewhere in app
export const changeLanguage = (lng) => i18n.changeLanguage(lng);

export default i18n;
